/* Create notification */
/* -------------------------------------------------------------------------------------- */
function addMiniCartNotification(product_id, flagParent, productParent) {
	$.getJSON('/cart.js').then(
		function(cart) {
			var notificationPopup = $('[js-cart-notification]');
			var items = cart.items;
			notificationPopup.addClass('active');
			notificationPopup.find('.js-cart-items-notification').empty();
			// Product search
			if (flagParent === true) {
				renderProductParent(product_id, items, notificationPopup);
				notificationPopup.find('[data-product-list-child]').empty();
			}else {
				renderProductParent(productParent, items, notificationPopup);
				renderProductChilden(product_id, items, notificationPopup);
			}
			// Header count
			$('[data-cart-count-bubble]').removeClass('d-none');
			$('[data-cart-count]').text(cart.item_count);
		}
	);
}
/* Update notification */
/* -------------------------------------------------------------------------------------- */
function updateCartNotification(iQuantity, line_item, product_id, flagParent) {
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: iQuantity,
			line: line_item
		},
		dataType: 'json',           
		success: function() {
			// Render notification cart
			addMiniCartNotification(product_id, flagParent);
		},
		complete: function() {
		},
		error: function() {
		}
	});
}
/* Show parent product - notification */
/* -------------------------------------------------------------------------------------- */
function renderProductParent(productParent, cart_items, notificationPopup) {
	var items = cart_items;
	var index = items.findIndex(item => item.id === productParent);
	if (index != -1) {
		var cart_title = items[index].product_title,
			cart_price = (items[index].price)/100,
			cart_subtotal = (items[index].final_line_price)/100,
			cart_image = "url('" + items[index].image + "')",
			cart_iQuantity = items[index].quantity,
			cart_iOptions = items[index].options_with_values,
			cart_iOptionsHTML = ' ';				  
			for(let i = 0; i < cart_iOptions.length; i++){
				var cart_iOptionsLabel = cart_iOptions[i].name == 'Size' ? 'Talla' : cart_iOptions[i].name;
				let cart_iOption = '<div class="c-cart-pop-mini__data-variant mb-p20">' +
								'<span>' + cart_iOptionsLabel + ': </span>'+ cart_iOptions[i].value +
								'</div>';
				cart_iOptionsHTML = cart_iOptionsHTML + cart_iOption;
			}
		notificationPopup.find('[data-product-title-popup]').append(cart_title);
		notificationPopup.find('[data-product-option-popup]').append(cart_iOptionsHTML);
		notificationPopup.find('[data-product-price-popup]').append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cart_price));
		notificationPopup.find('[data-product-subtotal-popup]').append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cart_subtotal));
		notificationPopup.find('[data-product-image-popup]').append('<span class="c-cart-notification__product-image" style="background: ' + cart_image + 'no-repeat center center; background-size: cover;"></span>');
		notificationPopup.attr('data-product-line', index + 1);
		notificationPopup.attr('data-product-id', productParent);
		notificationPopup.find('.js-quantity-input').val(cart_iQuantity);
		// JIBBITZ products
		notificationPopup.find('.js-add-cart-notification').attr('data-product-id-parent', productParent);
	}
}
/* show child products - notification */
/* -------------------------------------------------------------------------------------- */
function renderProductChilden(productChild, cart_items, notificationPopup) {
	var items = cart_items;
	var index = items.findIndex(item => item.id === productChild);
	if (index != -1) {
		var cart_image = "url('" + items[index].image + "')";
		var cart_image_content = '<span class="c-cart-notification__product-child-image" style="background: ' + cart_image + 'no-repeat center center; background-size: cover;"></span>';
		notificationPopup.find('[data-product-list-child]').append(cart_image_content);
	}
}
document.addEventListener('DOMContentLoaded', () => {
	/* Add to cart - Product */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '.js-add-cart-notification', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_id = parseFloat(el.attr("data-product-variant-id"));
		var product_quantity = parseFloat(el.attr("data-product-quantity"));
		var flagParent = (el.attr("data-product-flag-parent") == undefined) ? true : JSON.parse(el.attr("data-product-flag-parent"));
		var productParent = parseFloat(el.attr("data-product-id-parent"));
		// Product loading message on CARD
		el.find('[data-add-to-cart-text]').addClass('d-none');
		el.find('[data-loader]').removeClass('d-none');
		// Product loading message on QUICKVIEW
		el.closest('[js-quick-view-product]').find('[data-loader]').removeClass('d-none');
		el.closest('[js-quick-view-product]').find('[data-add-to-cart-text]').addClass('d-none');
		if (el.hasClass('js-close-quickview')) {
			$('[js-quick-view-product]').removeClass('active');
		}
		// ADD Product to cart
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: product_quantity,
				id: product_id
			},
			dataType: 'json',
			success: function(){
				// Turn on notification
				addMiniCartNotification(product_id, flagParent, productParent);
			},
			complete: function(){
				el.find('[data-loader]').addClass('d-none');
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').removeClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty();
				// Product loading message on QUICKVIEW
				if (el.hasClass('js-close-quickview')) {
					$('[js-quick-view-product]').removeClass('active');
					el.closest('[js-quick-view-product]').find('[data-loader]').addClass('d-none');
					el.closest('[js-quick-view-product]').find('[data-add-to-cart-text]').removeClass('d-none');
				}
			},
			error: function(response) {
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				el.find('[data-loader]').addClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').addClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty().append(response.responseJSON.description);
				// Product loading message on QUICK VIEW
				if (el.hasClass('js-close-quickview')) {
					el.closest('[js-quick-view-product]').find('[js-quickview-message]').addClass('active');
					el.closest('[js-quick-view-product]').find('[text-message-warning]').empty().append(response.responseJSON.description);
				}
			}
		});
	});
	/* Close - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-cart-notification]').on('click', '.js-close-data', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
			el.removeClass('active');
			item.removeClass('active');
			item.removeAttr('open');
	 });
	/* Quantity Product - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-cart-notification]').on('click', '[name=minus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-notification-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(spinner.closest('[js-cart-notification]').attr("data-product-line")),
			product_id = parseFloat(spinner.closest('[js-cart-notification]').attr("data-product-id"));
		if (oldValue <= min) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue - 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateCartNotification(newVal, line_item, product_id, true);
	});

	$('[js-cart-notification]').on('click', '[name=plus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-notification-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(spinner.closest('[js-cart-notification]').attr("data-product-line")),
			product_id = parseFloat(spinner.closest('[js-cart-notification]').attr("data-product-id"));
		if (oldValue >= max) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue + 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateCartNotification(newVal, line_item, product_id, true);
	});

	$('[js-cart-notification]').on('keyup', '.js-quantity-input', debounce(function(){
		var input = $(this),
			inputValue = parseFloat(input.val()),
			line_item = parseFloat(input.attr("data-index")),
			product_id = parseFloat(spinner.closest('[js-cart-notification]').attr("data-product-id"));
		updateCartNotification(inputValue, line_item, product_id, true);
	},500));
});